import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { servicesData } from "../../data/mock";

export const Services = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="relative">
      <div className="max-w-[1180px] mx-auto px-5 md:px-10">
        <div className="h-px bg-[rgba(10,10,10,0.08)]" />
      </div>

      <div
        ref={ref}
        className={`max-w-[1180px] mx-auto px-5 md:px-10 py-[60px] md:py-[80px] lg:py-[120px] transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h2 className="text-[clamp(26px,4vw,40px)] font-semibold leading-[1.2] tracking-tight text-[#0A0A0A] text-center mb-16">
          How We Work With Founders
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="group py-8 md:py-6 transition-transform duration-300 hover:-translate-y-1 cursor-default"
            >
              <h3 className="text-[22px] font-semibold leading-[1.3] text-[#0A0A0A] mb-4">
                {service.title}
              </h3>
              <p className="text-[16px] leading-[1.65] text-[rgba(10,10,10,0.5)]">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
